import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'

interface BatchDeleteDialogProps {
	count: number
	open: boolean
	isSubmitting?: boolean
	onOpenChange: (open: boolean) => void
	onConfirm: () => void
}

/** 批量删除送礼记录的二次确认弹窗 */
export function BatchDeleteDialog({ count, open, isSubmitting = false, onOpenChange, onConfirm }: BatchDeleteDialogProps) {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-[420px]">
				<DialogHeader>
					<DialogTitle>批量删除送礼记录</DialogTitle>
					<DialogDescription>删除后会返还对应礼物库存，此操作不可撤销。</DialogDescription>
				</DialogHeader>

				<div className="rounded-md border bg-muted/30 p-4 text-sm">
					<div className="text-muted-foreground">已选择送礼记录</div>
					<div className="text-xl font-bold">{count} 条</div>
				</div>

				<DialogFooter>
					<Button variant="outline" onClick={() => onOpenChange(false)} disabled={isSubmitting}>
						取消
					</Button>
					<Button variant="destructive" onClick={onConfirm} disabled={isSubmitting || count === 0}>
						{isSubmitting ? '删除中...' : '确认批量删除'}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
